<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :BackPath="'/Adaptive'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="true"
      :ImgUrl="'AD01.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "AD01",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "",
        title: "何謂適應性治療",
        list: [
          {
            body:
              "Adaptive Radiotherapy（適應性放射治療，ART）是一種能根據患者治療期間的身體與腫瘤變化，即時調整治療計畫的放射治療方式。"
          },
          {
            body:
              "傳統放射治療通常會依照治療前制定的計畫執行，而適應性治療則會根據患者每天的影像與解剖結構變化，重新評估並最佳化治療計畫，讓治療更貼近患者當下的身體狀況。"
          },
          {
            title: "個人化、高效率、更有信心",
            body:
              "Adaptive Intelligence 結合 AI 與先進影像技術，提供更貼近個人需求的治療方案。同時透過 AI 輔助規劃與自動化工作流程，提升臨床效率，並利用高品質影像與精確劑量計算，協助醫療團隊更有信心的制定與執行治療計畫。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
